export const GEOLOCATION_ENDPOIND = `https://ipgeolocation.abstractapi.com/v1/?api_key=${process.env.REACT_APP_ABSTRACT_API_API_KEY}`
